import React from 'react';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';

import M3Card from 'components/M3/M3Card';

import { HowItWorksItem } from './constants';

type CardProps = {
  index: number;
  item: HowItWorksItem;
};

const Card: React.FC<CardProps> = ({ index, item }) => {
  const isOdd = index % 2 !== 0;

  return (
    <Grid
      container
      display='flex'
      flexDirection={{
        xs: 'column',
        sm: 'row',
      }}
      justifyContent='space-between'
      alignItems='flex-start'
      spacing={1}
    >
      <Grid item xs={12} md={6} position='relative' zIndex={2}>
        <Box display='flex' flexDirection='column' mb={3}>
          <Typography
            fontSize={{
              xs: '20px',
              sm: '26px',
              md: '36px',
            }}
            fontWeight={500}
            lineHeight={{
              xs: '24px',
              sm: '30px',
              md: '44px',
            }}
            gutterBottom
            mt={4}
            mb={{
              xs: 4,
              md: 5,
            }}
          >
            {item.title}
          </Typography>
          <Typography fontSize='16px' fontWeight={400} lineHeight='24px'>
            {item.description}
          </Typography>
        </Box>
      </Grid>
      <Grid item xs={12} md={6}>
        <M3Card
          noHover
          sx={{
            mb: 5,
            display: 'flex',
            justifyContent: 'center',
          }}
        >
          <Box
            sx={{
              img: {
                borderRadius: 4,
                maxWidth: {
                  lg: 300,
                  md: 250,
                },
                objectFit: {
                  xs: 'contain',
                  sm: 'contain',
                  md: 'cover',
                  lg: 'cover',
                },
              },
            }}
          >
            <img src={item.image} />
          </Box>
        </M3Card>
      </Grid>
    </Grid>
  );
};

export default Card;
